var Request = require('../helper/request');
var Like = require('./comment/like');
var Hashtag = require('./comment/hashtag');
var Mention = require('./comment/mention');
var Extension = require('./comment/extension');

function Comment(app, feedId){
  var self = this;
  self.app = app;
  self.request = new Request(app);
  self.feedId = feedId;

  self.routes = {
    index: {
      url: '/feed/'+self.feedId+'/comment',
      method: 'GET'
    },
    show: {
      url: '/feed/'+self.feedId+'/comment/:id',
      method: 'GET'
    },
    create: {
      url: '/feed/'+self.feedId+'/comment',
      method: 'POST'
    },
    update: {
      url: '/feed/'+self.feedId+'/comment/:id',
      method: 'PUT'
    },
    delete: {
      url: '/feed/'+self.feedId+'/comment/:id',
      method: 'DELETE'
    }
  }
}

Comment.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

Comment.prototype.paginate = function(page){
  var self = this;
  var uri = self.routes.index.url + '?page=' + page;
  return self.request.get(uri);
}

Comment.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
}

Comment.prototype.subPaginate = function(id, page){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id) + '?page=' + page;
  return self.request.get(uri);
}

Comment.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    comment: data
  });
}

Comment.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    comment: data
  });
}

Comment.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
}

Comment.prototype.like = function(commentId){
  var self = this;
  return new Like(self.app, self.feedId, commentId);
}

Comment.prototype.hashtag = function(commentId){
  var self = this;
  return new Hashtag(self.app, self.feedId, commentId);
}

Comment.prototype.mention = function(commentId){
  var self = this;
  return new Mention(self.app, self.feedId, commentId);
}

Comment.prototype.extension = function(commentId){
  var self = this;
  return new Extension(self.app, self.feedId, commentId);
}

module.exports = Comment;
